module.exports = __webpack_public_path__ + "img/greyEdit.a73c4965.svg";